<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" viewBox="0 0 18 18">
  <path fill-rule="evenodd" d="M2.25 5.25v7.5L9 16.5l6.75-3.75v-7.5L9 1.5 2.25 5.25Zm6 4.191-4.5-2.5v4.926l4.5 2.5V9.441ZM4.567 5.68 9 8.142l4.434-2.463L9 3.216 4.567 5.679Z" clip-rule="evenodd"/>
</svg>
